@let departureAirport = data.flightItineraries[0].departureAirport.cityName;
@let arrivalAirport = data.flightItineraries[0].arrivalAirport.cityName;

<ds-border-wrapper>
  <div class="w-100 booking-trip-card">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex g-6 align-items-center">
        <img
          class="booking-trip-card-travel"
          src="assets/icons/travel.svg"
          alt="travel"
          height="24"
          width="24"
        />
        <div class="d-flex flex-column g-1">
          <lead-details-title
            [textSize]="'small'"
            [type]="data.tripType"
            [from]="departureAirport"
            [to]="arrivalAirport"
          />
          <div class="d-flex g-5 align-items-center">
            <p class="booking-trip-card-id" data-id="booking-id">Booking: {{ data.portalLink }}</p>
            @if (confirmationNumbers) {
              <p data-id="booking-confirmation-number">
                Confirmation number{{ data.airlineConfirmations?.length === 1 ? '' : 's' }}:
                {{ confirmationNumbers }}
              </p>
            }
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center booking-trip-card-icons">
        <logos-container [flightItineraries]="data.flightItineraries" />
        @if (isClickable) {
          <img src="assets/icons/booking_arrow.svg" alt="arrow" />
        }
      </div>
    </div>
  </div>
</ds-border-wrapper>
